// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2pWD8","head":"ProcedureTableInfo_head__3LgL-"};